module.exports = __webpack_public_path__ + "img/teacher-f2.28260a1f.png";